<div class="project-status-controls">
  <!-- <button class="collapse-btn" (click)="toggleTabContent()" [class.collapsed]="!isTabContentVisible">
    <img src="assets/images/pr-ham.png" alt="Collapse">
  </button> -->


  <div class="tabs-container" *ngIf="isTabContentVisible">
    <div class="tab" [class.active]="selectedTab === 'hours'" (click)="selectTab('hours')">
      <i class="wl_icon_Time-Summary"></i>
      <p>Time Summary</p>

    </div>
    <div class="tab" [class.active]="selectedTab === 'other'" (click)="selectTab('other')">
      <i class="wl_icon_Notes"></i>
      <p>Notes</p>
    </div>
  </div>
</div>

<!-- Tab content -->
<div class="tab-content" *ngIf="isTabContentVisible">
  <div *ngIf="selectedTab === 'hours'" class="hour-tab">
    <div class="hour-tab">
      <div class="status-card">
        <h3 class="project-hours-status-title">Project Hours And Status</h3>

        <div class="status-container">
          <div class="chart-section">
            <!-- Project Status -->
            <div class="donut-container proj_stat_donut">
              <div class="gauge-wrapper">
                <div #projectStatusChartContainer class="gauge-chart"></div>
                <!-- Loading spinner overlay -->
                <div class="spinner-only" *ngIf="isChartsLoading">
                  <app-spinner [size]="20"></app-spinner>
                </div>
              </div>
              <div class="caption">Project Status</div>
            </div>

            <!-- Balance Hours -->
            <div class="donut-container filled_hrs_donut">
              <div #balanceHoursChartContainer class="gauge-chart"></div>
              <!-- Loading spinner overlay -->
              <div class="spinner-only" *ngIf="isChartsLoading">
                <app-spinner [size]="20"></app-spinner>
              </div>
            </div>
          </div>

          <div class="info-section">

            <ul class="stats">
              <li class="light"><span>Planned Hours :</span> <b>{{ projectHourStatus()?.totalPlannedHours ?? '-' }}</b>
              </li>
              <li class="green"><span>Hours Filled :</span> <b>{{ projectHourStatus()?.hourFilledData ?? '-' }}</b></li>
              <li class="blue"><span>Unfilled Hours :</span> <b>{{ projectHourStatus()?.unfilledHours ?? '-' }}</b></li>
              <li class="pink"><span>Offset Hours :</span> <b>{{ projectHourStatus()?.offsetHours ?? '-' }}</b></li>
            </ul>
          </div>
        </div>
      </div>


      <div class="user-input-card">
        <div class="card-title">
          User Input Hours <span class="total">({{ formatHours(projectHourData()?.totalBillableHours) }})</span>
        </div>

        <div class="section">
          <div class="section-header billable">
            <span>Billable</span>
            <b>{{ formatHours(projectHourData()?.totalBillableHours) }}</b>
          </div>
          <div class="row"><span>Task</span><span>{{ formatHours(projectHourData()?.totalTaskHours) }}</span></div>
          <div class="row"><span>Project</span><span>{{ formatHours(projectHourData()?.totalProjectHours) }}</span>
          </div>
          <div class="row"><span>Request</span><span>{{ formatHours(projectHourData()?.totalRequestHours) }}</span>
          </div>
          <div class="row"><span>Revisions</span><span>{{ formatHours(projectHourData()?.totalRevisionHours) }}</span>
          </div>
        </div>

        <div class="section">
          <div class="section-header non-billable">
            <span>Non Billable</span>
            <b>{{ formatHours(projectHourData()?.totalNonBillableHours) }}</b>
          </div>
          <div class="row"><span>Issue</span><span>{{ formatHours(projectHourData()?.totalIssueHours) }}</span></div>
          <div class="row"><span>Offset Hours</span><span>{{ formatHours(projectHourData()?.totalOffsetHours) }}</span>
          </div>
        </div>
      </div>

      <div class="goal-date-card">
        <div class="goal-date-top">
          <div class="goal-date-label">
            Completion Date
            <span #hintIconWrapper class="hint-icon-wrapper" tabindex="0"
              *ngIf="goalDateTooltipRows()[0]?.responsibility" (mouseenter)="onGoalDateHintEnter()"
              (mouseleave)="onGoalDateHintLeave()" (focus)="onGoalDateHintEnter()" (blur)="onGoalDateHintLeave()">
              <i class="wl_icon_hint hint-icon"></i>
            </span>
            <div #goalDateTooltip class="goal-date-tooltip new-format" *ngIf="showGoalDateTooltip"
              [ngClass]="{ 'invisible': !tooltipPositioned }" (mouseenter)="onGoalDateHintEnter()"
              (mouseleave)="onGoalDateHintLeave()">
              <div class="tooltip-header">
                <i class="fa fa-calendar-alt" style="margin-right: 8px;"></i>
                Projected Date Changes
              </div>
              <div class="tooltip-content">
                <div class="date-change-entry" *ngFor="let row of goalDateTooltipRows()">
                  <div class="entry-header">
                    <div class="change-summary">
                      <div class="change-item from">
                        <span class="label"><i class="wl_icon_calendar"></i> From:</span>
                        <span class="value">{{ row?.prevProjectedDate | date:'MMM d, y' }}</span>
                      </div>
                      <div class="change-item to">
                        <span class="label"><i class="wl_icon_calendar"></i> To:</span>
                        <span class="value">{{ row?.currentProjectedDate | date:'MMM d, y' }}</span>
                      </div>
                      <div class="change-item">
                        <span class="label"><i class="fa-regular fa-user"></i> By:</span>
                        <span class="value">{{ row?.changedBy?.name }}</span>
                      </div>
                      <!-- <div class="change-item">
                        <span class="label">🗓️ On:</span>
                        <span class="value">{{ row?.createdAt | date:'MMM d' }}</span>
                      </div> -->
                    </div>
                    <div class="meta-info">
                      <div class="left-meta">
                        <span>{{ row?.createdAt | date:'MMM d, y, hh:mm a' }}</span>
                      </div>
                      <div class="responsibility-badge" *ngIf="row?.responsibility">
                        {{ row?.responsibility }}
                      </div>
                    </div>
                  </div>
                  <div class="entry-reason" *ngIf="row?.reason">

                    <p class="reason-text" style="text-transform: capitalize;"><span
                        style="font-weight: 600; font-style:normal ;">Reason:</span> {{ row?.reason }}</p>
                  </div>
                </div>
              </div>

              <!-- Fallback table for compatibility -->
              <table class="tooltip-table">
                <thead>
                  <tr>
                    <th>Prev.Date</th>
                    <th>Changed To</th>
                    <th>Changed By</th>
                    <th>Changed On</th>
                    <th>Responsibility</th>
                  </tr>
                </thead>
                <tbody>
                  <tr *ngFor="let row of goalDateTooltipRows()">
                    <td>{{ row?.prevProjectedDate | date:'MMM d, y' }}</td>
                    <td>{{ row?.currentProjectedDate | date:'MMM d, y' }}</td>
                    <td>{{ row?.changedBy?.name }}</td>
                    <td>{{ row?.createdAt | date:'MMM d, y' }}</td>
                    <td>{{ row?.responsibility }}</td>
                  </tr>
                </tbody>
              </table>
            </div>
          </div>
          <div class="goal-date-main">
            <div class="goal-date">
              <span class="goal-day">
                {{ projectsPlannedDateLog()?.currentProjectedDate ? (projectsPlannedDateLog().currentProjectedDate |
                date:'d') : '-' }}
              </span>
              <span class="goal-month">
                {{ projectsPlannedDateLog()?.currentProjectedDate ? (projectsPlannedDateLog().currentProjectedDate |
                date:'MMMM') : '-' }}
              </span>
              <div class="datepicker-container">
                <input [matDatepicker]="datepicker" name="goalDate" [(ngModel)]="selectedGoalDate"
                  (ngModelChange)="onDateChange()" class="datepicker-input" readonly>
                <button mat-icon-button class="edit-icon" (click)="openProjectCompletionModal()">
                  <i class="wl_icon_edit_btn"></i>
                </button>
                <!-- <mat-datepicker #datepicker (closed)="onDateChange()"></mat-datepicker> -->
              </div>
            </div>
          </div>
        </div>

        <div class="goal-date-bottom">
          <div class="meta-item">
            <span class="meta-label">Changed on</span>
            <span class="meta-value link">
              {{ projectsPlannedDateLog()?.updatedAt ? (projectsPlannedDateLog().updatedAt | date:'MMM d, y') : '-' }}
            </span>
          </div>
          <div class="meta-item">
            <span class="meta-label">Changed by</span>
            <span class="meta-value link">{{projectsPlannedDateLog()?.changedBy?.name ?? '-' }}</span>
          </div>

          <div class="meta-item">
            <span class="meta-label">Changed to</span>
            <span class="meta-value link">
              {{ projectsPlannedDateLog()?.currentProjectedDate ? (projectsPlannedDateLog().currentProjectedDate |
              date:'MMM d, y') : '-' }}
            </span>
          </div>
          <div class="meta-item">
            <span class="meta-label">Responsibility</span>
            <span class="meta-value link">
              {{ projectsPlannedDateLog()?.responsibility ? projectsPlannedDateLog().responsibility : '-' }}
            </span>
            <!-- <div class="meta-value select">
              <ng-select
                [items]="responsibilityOptions"
                bindLabel="name"
                class="custom-ng-select"
                [(ngModel)]="selectedResponsibility"
                (ngModelChange)="onResponsibilityChange($event)"
                [clearable]="false"
                [searchable]="false"
                appendTo="body"
                dropdownPosition="top">
              </ng-select>
            </div> -->
          </div>
        </div>
      </div>
    </div>

  </div>

  <div *ngIf="selectedTab === 'other'">
    <!-- Notes Tab Content -->
    <div class="project-status-container">
      <!-- Loading Spinner for Notes -->
      <div class="notes-loading-spinner" *ngIf="notesLoading()">
        <app-spinner [size]="40"></app-spinner>
      </div>

      <!-- Add New Note Button -->
      <button class="add-note-btn" (click)="onAddNoteClick()" *ngIf="!notesLoading()">
        Add New Note
        <span class="add-icon">
          <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
            <path d="M7 10L12 15L17 10" stroke="white" stroke-width="2" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </span>
      </button>

      <!-- Add Note Form -->
      <div class="add-note-form" *ngIf="showAddNoteForm() && !notesLoading()">
        <quill-editor class="note-input" [(ngModel)]="newNoteText" [ngModelOptions]="{updateOn: 'change'}"
          [modules]="quillConfig" placeholder="Enter your note..."
          (keydown.control.enter)="addNewNote()"></quill-editor>

        <!-- Selected Files Preview (only show if files are selected) -->
        <div class="selected-files" *ngIf="selectedFiles.length > 0">
          <div class="files-header">
            <span class="files-count">{{ selectedFiles.length }} file(s) selected</span>
            <button class="clear-files-btn" (click)="clearSelectedFiles()" title="Clear all files">
              <i class="wl_icon_close"></i>
            </button>
          </div>
          <div class="files-list">
            <div class="file-item" *ngFor="let file of selectedFiles; let i = index">
              <div class="file-info">
                <i [class]="getFileIcon(file.type)" class="file-icon"></i>
                <div class="file-details">
                  <span class="file-name">{{ file.name }}</span>
                  <span class="file-size">{{ formatFileSize(file.size) }}</span>
                </div>
              </div>
              <button class="remove-file-btn" (click)="removeFile(i)" title="Remove file">
                <i class="wl_icon_close"></i>
              </button>
            </div>
          </div>
        </div>

        <div class="form-actions">
          <button class="btn-save" (click)="addNewNote()"
            [disabled]="(!newNoteText().trim() && selectedFiles.length === 0) || addNoteLoading()">
            @if (addNoteLoading()) {
              <app-spinner [size]="16"></app-spinner>
            } @else {
              Save
            }
          </button>
          <button class="btn-cancel" (click)="cancelAddNote()" [disabled]="addNoteLoading()">
            Cancel
          </button>
        </div>
      </div>

      <!-- Notes List -->
      <div *ngIf="!notesLoading()">
        <div *ngFor="let note of sortedNotes(); let i = index" class="note-card" [class.pinned]="note.isPinned"
          [style.background]="getCardBackgroundColor(i)" [style.border-color]="getCardBorderColor(i)">
          <!-- Dynamic pinned overlay -->
          <div *ngIf="note.isPinned" class="pinned-overlay" [style.background]="getPinnedOverlayColor(i)">
          </div>

          <div class="note-header">
            <!-- <button class="pin-btn" (click)="togglePin(note.id)" [class.pinned]="note.isPinned"
            [title]="note.isPinned ? 'Unpin note' : 'Pin note'">
            <i class="wl_icon_pin" [ngClass]="note.isPinned ? 'pinned' : 'unpinned'"></i>
          </button> -->
            <button class="close-btn" (click)="deleteNote(note.id)" matTooltip="Delete Note">
              <mat-icon>close</mat-icon>
            </button>
          </div>

          <div class="note-content">
            <!-- Edit Mode -->
            <div *ngIf="isEditingNote(note.id)" class="edit-mode">
              <quill-editor class="note-edit-input" [(ngModel)]="note.text" [modules]="quillConfig" #editInput
                (keydown.control.enter)="saveEditNote(note.id, note.text)"
                (keydown.escape)="cancelEditNote()"></quill-editor>
              <div class="edit-actions">
                <button class="btn-save" (click)="saveEditNote(note.id, note.text)" [disabled]="editNoteLoading()">
                  @if (editNoteLoading()) {
                    <app-spinner [size]="16"></app-spinner>
                  } @else {
                    Save
                  }
                </button>
                <button class="btn-cancel" (click)="cancelEditNote()" [disabled]="editNoteLoading()">
                  Cancel
                </button>
              </div>
            </div>

            <!-- View Mode -->
            <div *ngIf="!isEditingNote(note.id)" class="view-mode">
              <div 
                class="note-text-content"
                (dblclick)="startEditNote(note.id)" 
                title="Double-click to edit" 
                [innerHTML]="note.text || ''">
              </div>

              <div class="note-meta" *ngIf="note.type === 'video' || note.type === 'audio'">
                <div class="audio-list">
                  <div class="audio-row">
                    <button class="audio-btn" (click)="openFilePreview(note)"
                      [title]="'Preview ' + (note.type === 'video' ? 'video' : 'audio')">
                      <i [class]="note.type === 'video' ? 'wl_icon_doc-video' : 'wl_icon_doc-video'"></i>
                    </button>
                    <span class="audio-time">{{ note.time }}</span>
                  </div>
                </div>
              </div>

              <div class="note-meta1" *ngIf="note.type === 'image'">
                <button class="image-btn" (click)="openFilePreview(note)" title="Preview image">
                  <i class="wl_icon_img-icon"></i>
                </button>
              </div>

              <div class="note-meta1" *ngIf="note.type === 'document'">
                <button class="document-btn" (click)="openFilePreview(note)" [title]="'Open ' + note.fileName">
                  <i [class]="getDocumentIcon(note.fileType || '')"></i>
                </button>
              </div>

              <div class="note-footer-actions">
                <div class="note-footer">{{ note.user }} | {{ note.date }}</div>
                <!-- <button class="edit-note-btn" (click)="startEditNote(note.id)" title="Edit note">
                <i class="wl_icon_edit"></i>
              </button> -->
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- No Data State -->
      <div class="no-data-container" *ngIf="sortedNotes().length === 0 && !notesLoading()">
        <div class="no-data-content">
          <mat-icon class="no-data-icon">description</mat-icon>
          <h3 class="no-data-title">No Notes Available</h3>
          <p class="no-data-message">There are no notes for this project yet. Click "Add New Note" to create your first
            note.</p>
        </div>
      </div>
    </div>

  </div>
</div>

<!-- Project Completion Modal Slider -->
<app-project-completion-modal *ngIf="showProjectCompletionSlider()" [modalData]="projectCompletionModalData()"
  (modalClosed)="onProjectCompletionModalClosed()" (formSubmitted)="onProjectCompletionFormSubmitted($event)">
</app-project-completion-modal>

<app-confirm-popup [show]="showDeleteConfirmPopup()" [title]="'Delete Note'"
  [message]="'Are you sure you want to delete this note? This action cannot be undone.'" [confirmText]="'Delete'"
  [cancelText]="'Cancel'" [type]="'delete'" [loading]="deleteNoteLoading()" (confirm)="onDeleteConfirm()"
  (cancel)="onDeleteCancel()">
</app-confirm-popup>

<!-- File Preview Modal -->
<div class="file-preview-modal" *ngIf="showFilePreview()" (click)="closeFilePreview()">
  <div class="file-preview-backdrop"></div>

  <div class="file-preview-container" (click)="$event.stopPropagation()">
    <!-- Modal Header -->
    <div class="file-preview-header">
      <div class="file-info">
        <div class="file-details">
          <h3 class="file-name">{{ currentFilePreview()?.fileName }}</h3>
          <span class="file-type">{{ currentFilePreview()?.fileType }}</span>
        </div>
      </div>
      <div class="file-actions">
        <button class="action-btn download-btn" (click)="downloadFile($event)" title="Download file">
          <i class="fas fa-download"></i>
        </button>
        <button class="action-btn close-btn" (click)="closeFilePreview()" title="Close preview">
          <i class="fas fa-times"></i>
        </button>
      </div>
    </div>

    <!-- Modal Body -->
    <div class="file-preview-body">
      <!-- Image Preview -->
      <div *ngIf="currentFilePreview()?.type === 'image'" class="image-preview">
        <img [src]="currentFilePreview()?.fileUrl" [alt]="currentFilePreview()?.fileName" class="preview-image">
      </div>

      <!-- Video Preview -->
      <div *ngIf="currentFilePreview()?.type === 'video'" class="video-preview">
        <video [src]="currentFilePreview()?.fileUrl" controls class="preview-video" controlsList="nodownload">
          Your browser does not support the video tag.
        </video>
      </div>

      <!-- Audio Preview -->
      <div *ngIf="currentFilePreview()?.type === 'audio'" class="audio-preview">
        <div class="audio-player-wrapper">
          <i class="wl_icon_doc-video audio-icon"></i>
          <audio [src]="currentFilePreview()?.fileUrl" controls class="preview-audio" controlsList="nodownload">
            Your browser does not support the audio tag.
          </audio>
        </div>
      </div>

      <!-- Document Preview -->
      <ng-container *ngIf="currentFilePreview()?.type === 'document'">
        <div class="document-preview" *ngIf="currentFilePreview() as preview">
          <iframe [src]="preview.fileUrl" class="preview-document"
            *ngIf="preview.fileType && preview.fileType.includes('pdf')">
          </iframe>
          <div class="document-placeholder" *ngIf="!preview.fileType || !preview.fileType.includes('pdf')">
            <i class="wl_icon_doc-export placeholder-icon"></i>
            <p>Document preview not available</p>
            <button class="download-document-btn" (click)="downloadFile($event)">
              <i class="fas fa-download"></i>
              Download to view
            </button>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>